import React, { FC } from 'react'
import { PhoneInputProps } from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useTheme } from 'styled-components'

import * as SC from './styled'

export type FormPhoneProps = Omit<PhoneInputProps, 'onChange'> & {
  className?: string
  name: string
  value?: string
  label?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  error?: string
  showError?: boolean
  help?: string
  onChange?: (event: { target: { name: string; value: string } }) => void
}

const FormPhone: FC<FormPhoneProps> = (props) => {
  const {
    className,
    name,
    label,
    error,
    showError = true,
    help,
    onChange,
    ...phoneInputProps
  } = props

  const theme = useTheme()

  return (
    <SC.Container className={className} $isDisabled={phoneInputProps.disabled}>
      {label && <SC.Label required={phoneInputProps.required}>{label}</SC.Label>}
      <SC.Input
        preferredCountries={['fr']}
        country={'fr'}
        {...phoneInputProps}
        $isDisabled={phoneInputProps.disabled}
        inputStyle={{
          height: 'auto',
          width: '100%',
          paddingBottom: '12px',
          paddingTop: '12px',
          paddingRight: '12px',
          lineHeight: '1.5',
          fontSize: '14px',
          color: `${error ? theme.colors.red : theme.colors.pureBlack}`,
          border: `1px solid ${error ? theme.colors.red : theme.colors.pureBlack}`,
          borderRadius: '0',
        }}
        buttonStyle={{
          borderRadius: '0',
          border: `1px solid ${error ? theme.colors.red : theme.colors.pureBlack}`,
          backgroundColor: `${theme.colors.pureWhite}`,
        }}
        onChange={(value, _data, _event, _formattedValue) => {
          onChange?.({
            target: {
              name,
              value: `+${value}`,
            },
          })
        }}
      />
      {help && <SC.Help>{help}</SC.Help>}
      {error && showError && <SC.Error>{error}</SC.Error>}
    </SC.Container>
  )
}

export default FormPhone
